import { FC, ReactNode, createContext, useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useCurrentUser } from '@/lib/auth-service';

export interface UserContext {
  isAccountManagerMode?: boolean;
  setAccountManagerMode?: (mode?: boolean) => void;
}

interface AccountProviderProps {
  children: ReactNode;
}

const defaultState: UserContext = {};

const UserContext = createContext<UserContext>(defaultState);

export const UserProvider: FC<AccountProviderProps> = ({ children }) => {
  const posthog = usePostHog();
  const { user, isLoading } = useCurrentUser();
  useEffect(() => {
    if (!isLoading) {
      posthog.setPersonProperties({ email: user.primaryEmail });
    }
  }, [user]);

  return <>{children}</>;
};
